module.exports = "http://cdn.realive.com.ua/src/views/player/documets/ems/images/serial.png";